import { z } from 'zod';

export const loginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1),
  terms: z.literal(true, { errorMap: () => ({ message: 'Debes aceptar los términos' }) }),
});

export type LoginInput = z.infer<typeof loginSchema>;

export const signupDemoSchema = z.object({
  fullName: z.string().min(1, 'Campo requerido'),
  email: z.string().email('Email inválido'),
  phone: z.string().min(1, 'Campo requerido'),
  password: z.string().min(1, 'Campo requerido'),
  terms: z.literal(true, { errorMap: () => ({ message: 'Debes aceptar los términos' }) }),
});

export type SignupDemoInput = z.infer<typeof signupDemoSchema>;

export const resetPasswordSchema = z
  .object({
    password: z.string().min(1, 'Campo requerido'),
    repassword: z.string().min(1, 'Campo requerido'),
  })
  .refine(data => data.password === data.repassword, {
    message: 'Las contraseñas deben coincidir',
    path: ['repassword'],
  });

// El API exige 8 caracteres como mínimo: se valida aquí para avisar antes de enviar.
export const changePasswordSchema = z
  .object({
    password: z.string().min(8, 'La contraseña debe tener al menos 8 caracteres'),
    repassword: z.string().min(1, 'Campo requerido'),
  })
  .refine(data => data.password === data.repassword, {
    message: 'Las contraseñas deben coincidir',
    path: ['repassword'],
  });

export type ChangePasswordInput = z.infer<typeof changePasswordSchema>;
